












































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetLeftCategory, AddShiti } from "@/request/storehouse";
import { GetDaohang } from "@/request/schema";
import { GetSechemaList } from "@/request/mark";
@Component({
  components: {},
})
export default class Name extends Vue {
  @Prop()
  private currentTree: any;
  @Prop()
  private yuyiData: any;
  @Watch("yuyiData", { immediate: true })
  private yuyiDataChange(val: any) {
    console.log("yuyiDataChange");
    console.log(val);
    this.editData["语义类型"] = val;
    this.$forceUpdate();
  }
  @Prop()
  private ifShow: any;
  @Watch("ifShow")
  private ifShowChange(val: any) {
    this.ifShowEdit = val;
    console.log("ifShowChange");
    console.log(this.yuyiData);
    if (val) {
      this.editData = {};
      if (this.currentTree["类型"] == "实体") {
        this.editData["上位概念"] = [
          {
            name: this.currentTree["名称"],
            id: this.currentTree._id,
          },
        ];
      }
      if (this.yuyiData && this.yuyiData._id) {
        this.editData["语义类型"] = this.yuyiData;
        this.$forceUpdate();
        this.getTypes();
      } else {
        this.getNav();
      }
    }
  }
  private ifShowEdit: boolean = false;
  private editData: any = {};
  private yuyileixingList: any = [];
  private yuyiNav: any = [];
  private props: any = {
    label: "name",
  };
  private ifShowTree: any = false;
  private fenleiData: any = [];
  private defaultProps: any = {
    label: "域名称",
  };
  private handleYuyiNodeClick(data: any, node: any) {
    this.editData["语义类型"] = node.data;
    this.$forceUpdate();
    this.ifShowTree = false;
    this.getTypes();
  }

  private getNav() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          type: "语义类型",
        },
      };
      GetDaohang(this, params, loading).then((res: any) => {
        loading.close();
        this.yuyiNav = res;
        resolve(res);
      });
    });
  }
  private handleCheckChange(data: any, checked: any, indeterminate: any) {
    const checkData: any = (this.$refs.optTree as any).getCheckedNodes();
    this.editData["上位概念"] = checkData;
    this.$forceUpdate();
  }
  private leixingChange(item: any) {
    this.editData["语义类型"] = {
      _id: item._id,
      域id: item._id,
      域名称: item.label,
      label: item.label,
      color: item.color,
    };
    this.$forceUpdate();
    this.ifShowTree = false;
    this.getTypes();
  }
  private getTypes() {
    console.log("getTypes");
    const params: any = {
      params: {
        _id: "",
        语义id: this.editData["语义类型"]["域id"],
      },
    };
    GetLeftCategory(this, params).then((res: any) => {
      this.fenleiData = res;
      console.log(this.fenleiData);
      if (this.fenleiData.length > 0) {
        this.ifShowTree = true;
      }
    });
  }
  private searchYuyiOptions(e: any) {
    const params: any = {
      params: {
        search: e,
        type: "语义类型",
      },
    };
    GetSechemaList(this, params).then((data: any) => {
      this.yuyileixingList = data;
    });
  }
  private loadNode(node: any, resolve: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        _id: node.data ? node.data._id : "",
        语义id: this.editData["语义类型"]["域id"],
      },
    };
    GetLeftCategory(this, params, loading)
      .then((res: any) => {
        loading.close();
        resolve(res);
      })
      .catch(() => {
        loading.close();
        resolve([]);
      });
  }
  private cancel() {
    this.$emit("cancel");
  }
  private addSure() {
    if (!this.editData["语义类型"] || !this.editData["语义类型"]["域id"]) {
      this.$message.warning("请选择语义类型");
      return;
    }
    if (!this.editData["名称"]) {
      this.$message.warning("请输入实体名称");
      return;
    }
    const params: any = {
      上位概念: this.editData["上位概念"],
      语义id: this.editData["语义类型"]["域id"],
      实体名称: this.editData["名称"],
      是否临时: "标准实体",
    };
    AddShiti(this, params).then((res: any) => {
      this.$message.success("添加成功");
      this.$emit("addSure", res);
    });
  }
  private mounted() {}
}
